export const MARITAL_STATUS_LIST = [
  {
    label: 'Solteiro(a)',
    value: 1,
  },
  {
    label: 'Casado(a)',
    value: 2,
  },
  {
    label: 'Separado(a)',
    value: 3,
  },
  {
    label: 'Divorciado(a)',
    value: 4,
  },
  {
    label: 'Viúvo(a)',
    value: 5,
  },
];
